import { ScreenName } from '@helpcenter/constants';
import { createRouteWithLayout } from '@atlassian/help-center-common-util/resource-router';
import { AsyncSurveyDetails } from '@atlassian/surveys-portal';

export const getSurveyRoute = () =>
    createRouteWithLayout(
        {
            name: 'survey',
            path: '/portal/:portalId/survey/:surveyId',
            exact: true,
            component: AsyncSurveyDetails,
            resources: [],
        },
        ScreenName.SURVEY,
        {
            fadeInSearchModal: true,
            paperAppearance: 'xxwide',
        }
    );
